import React from "react";
import {useTranslation} from "react-i18next";
import {OrderItemInterface} from "../../services/exports/Interfaces";
import PhoneIcon from "../../assets/logo/PhoneIcon";

interface Props {
  order: OrderItemInterface;
  className?: string;
}

export default function DeliveryTracker(props: Props) {
  const { t } = useTranslation(null, {keyPrefix: 'Components:Delivery:DeliveryTracker'});

  const { order, className } = props;

  return order?.delivery?.runner_name ? (
    <div className={className}>
      <h4>{t('title')}</h4>
      <p className="mt-small">{order.delivery.runner_name}</p>
      {order.delivery.runner_phone_number ? (
        <div className="flex mt-small">
          <p className="my-auto">{order.delivery.runner_phone_number}</p>
          <a
            href={`tel:${order.delivery.runner_phone_number}`}
            className="h-9 w-9 ml-mini bg-brand-secondary flex justify-center items-center rounded-full"
          >
            <PhoneIcon color="white" />
          </a>
        </div>
      ) : null}
      {order.delivery.tracking_url ? (
        <a
          href={order.delivery.tracking_url}
          target="_blank"
          rel="noreferrer noopener"
          className="mt-small block w-full p-xsmall text-center rounded-md bg-companyBrand-primary text-white font-semibold"
        >{t('buttons.track_driver')}</a>
      ) : null}
    </div>
  ) : null;
}
